<template>
  <div>
    <div id="resultados-modal-id" class="resultados-modal elevation-20">
      <v-row no-gutters>
        <v-col class="text-right">
          <dialog-prestacion-componente :id="id" v-if="area.includes('prestacion')"
                                        @actualizado="actualizadaPonderacion"/>

          <v-btn text icon color="secondary">
            <v-icon @click="cerrar()" size="36">mdi-close-box</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col>
          <proyecto-resultados-pagina v-if="mostrarResultados" :prop-tipo-area="area" :prop-tipo="tipo"
                                      :prop-id="id"
                                      class="pa-5 pt-2"/>
        </v-col>
      </v-row>
    </div>
  </div>

</template>

<script>
import ProyectoResultadosPagina from "../../proyecto-resultados/ProyectoResultadosPagina";
import DialogPrestacionComponente from "@/paginas/proyecto-resultados/Componentes/DialogPrestacionComponente";

export default {
  components: {
    ProyectoResultadosPagina,
    DialogPrestacionComponente
  },
  name: 'ProyectoResultadosModal',
  props: [
    'activado',
    'area',
    'tipo',
    'id',
  ],
  data: () => ({
    obligaAgirar: false,
    modalPrestacion: false,
    mostrarResultados: true
  }),
  mounted() {
    window.addEventListener("orientationchange", function () {
      this.estableceObligaAgirar();
    });
    this.estableceObligaAgirar();
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    estableceObligaAgirar() {
      if (this.$vuetify.smAndUp) return false;
      if (!Object.prototype.hasOwnProperty.call(window, 'orientation')) return false;
      return false;
    },
    actualizadaPonderacion() {
      this.mostrarResultados = false;
      setTimeout(() => {
        this.mostrarResultados = true;
      });
      this.$emit("actualizadaPonderacion");
    }
  }
};
</script>

<style lang="scss" scoped>
#mensaje-girar {
  background: #1EE8B8;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 999;

  .texto {
    font-size: 30px;
    text-align: center;
    margin-top: 20%;
  }
}

.resultados-modal {
  position: absolute;
  background: white;
  z-index: 10000;
  top: 60px;
  left: 0;
  right: 0;
  width: 100%;
  min-height: 600px;
  /*position: relative;*/
  border: 2px solid #1EE8B8;
  /*box-shadow: none !important;*/
  .cerrar {
    position: absolute;
    right: 5px;
    top: 5px;
  }
}
</style>